export enum ConsentMethod {
  DIGITAL_SIGNATURE = 'DIGITAL_SIGNATURE',
  WEB_FORM = 'WEB_FORM',
  KIOSK = 'KIOSK',
  MANUAL_ENTRY = 'MANUAL_ENTRY',
  VERBAL = 'VERBAL',
  WRITTEN = 'WRITTEN',
  EMAIL_CONFIRMATION = 'EMAIL_CONFIRMATION',
  SMS_CONFIRMATION = 'SMS_CONFIRMATION',
  DOUBLE_OPT_IN = 'DOUBLE_OPT_IN',
}
